module.exports = [{
      plugin: require('C:/Users/micha/Documents/GitHub/sporadic-labs.github.io/node_modules/gatsby-plugin-layout/gatsby-browser'),
      options: {"plugins":[],"component":"C:\\Users\\micha\\Documents\\GitHub\\sporadic-labs.github.io\\src\\layouts\\index.js"},
    },{
      plugin: require('C:/Users/micha/Documents/GitHub/sporadic-labs.github.io/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[],"trackingId":"UA-116363382-1"},
    },{
      plugin: require('C:/Users/micha/Documents/GitHub/sporadic-labs.github.io/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('C:/Users/micha/Documents/GitHub/sporadic-labs.github.io/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
